<template>
    <div>
      <h1>Seems like you got lost!</h1>
      <h2>There is no page here, sorry!</h2>
      <router-link to="/" class="button back">
        <font-awesome-icon :icon="['fas', 'chevron-left']" class="fa-xs" />
        Home
      </router-link>
    </div>
  </template>
  